import { zhCN } from './zh-CN';
import { zhTW } from './zh-TW';
import { en } from './en';

export const locales = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en': en
};

export type Locale = keyof typeof locales;
export type LocaleMessages = typeof zhCN;

export const defaultLocale: Locale = 'zh-CN';

export const localeNames = {
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'en': 'English'
};